import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { FILE_INCORRECT } from "@/features/company/constants/excel";
import { TOption } from "@/types/common";
import dayjs from "dayjs";
const headers: string[] = [
  "求職活動ステータス", //recruitmentStatus
  "人材担当者", //personalInCharge
  "氏名", //fullName
  "生年月日", //birthday
  "呼び名", //nickName
  "人材管理番号", //talentNumber
  "国籍", //nationality
  "性別", //gender
  "電話番号", //phoneNumber
  "メールアドレス", //email
  "居住地", //location
  "郵便番号", //zipCode
  "所在地（町名丁目番地号等）", //address
  "本国における居住地", //country
  "在留資格", //residenceStatus
  "在留期限", //periodOfStay
  "特定技能1号起算日", //specifiedSkillFirstStartDate
  "ブランク期間（月単位）", //specifiedSkillFirstRemainingTerm
  "パスポート番号", //passportNumber
  "パスポート期限", //passportExpiryDate
  "分野", //specificBusinessClassificationFirst
  "区分", //specificBusinessClassificationTypeFirst
  "日本語能力証明書", //languageCertificates
  "日本語能力（その他）", //languageTestOther
  "特定技能合格証", //specificSkillCertificates
  "職種", //majorName
  "作業", //jobName
  "特性メモ", //memo
  "面談評価", //interviewEvaluation
  "家族構成", //familyInformation
  "希望職種（分野）", //desiredJobType
  "希望勤務地", //desiredWorkLocation
  "希望手取り額", //expectSalary
  "転職可能時期", //availableFrom
  "その他希望", //otherRequest
  "社内メモ", //internalMemo
  "面談日", //interviewDate
];

const handleDownloadExcel = async (data: string[][], listIndustry: TOption[] = [], customName: string = "talent-sample.xlsx") => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("人材情報");
  const industrySheet = workbook.addWorksheet("Industry");
  listIndustry.forEach((item, idx) => {
    industrySheet.getCell("A" + (idx + 1)).value = item.label;
  });
  industrySheet.state = "veryHidden";
  const headerRow = sheet.addRow(headers);
  for (const row of data) {
    sheet.addRow(row);
  }
  headerRow.eachCell((cell, colNumber) => {
    cell.font = { bold: true, size: 16, color: { argb: "FFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "4472C4" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    const column = sheet.getColumn(colNumber);
    column.width = 20;
  });

  const totalRows = 100;
  for (let i = 2; i <= totalRows + 1; i++) {
    const cell = sheet.getCell(`U${i}`);
    cell.dataValidation = {
      type: "list",
      formulae: ["=Industry!$A$1:$A$47"],
      showInputMessage: true,
    };
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, customName);
};

export const downloadSample = async (industry: TOption[] = []) => {
  const data = [
    "求職中",
    "本田",
    "NGUYEN THI PHUONG",
    "2003/10/09",
    "フォン",
    "TALENT01ベト",
    "ベトナム",
    "女性",
    "090-1234-5678",
    "nguyenthiphuong@gmail.com",
    "日本以外",
    "",
    "",
    "ベトナム",
    "特定技能1号",
    "2024/01/01",
    "2024/01/01",
    "",
    "TEST",
    "2025/12/30",
    "工業製品製造業",
    "機械金属加工|電気電子機器組立て",
    "日本語能力試験・N4|日本語能力試験・N3",
    "BJTビジネス日本語能力テスト",
    "介護技能評価試験の合格証明書|技能検定1級の合格証明書",
    "さく井",
    "パーカッション式さく井工事",
    "",
    "",
    "",
    "介護|飲食料品製造業",
    "東京",
    "20万円以上",
    "来月",
    "",
    "",
    "2025/12/30",
  ];
  const listIndustries = industry.filter((item) => !item.hidden);
  await handleDownloadExcel([data], listIndustries);
};

export const exportExcel = async (listData: string[][], listIndustry: TOption[] = [], matchName: string) => {
  await handleDownloadExcel(listData, listIndustry, `${matchName}_人材DB_${dayjs().unix()}.xlsx`);
};

export const validateFileFormat = (rowHeader: string[]) => {
  const header = rowHeader.filter((h) => h !== "").map((h) => String(h).trim());

  if (header.length !== headers.length) {
    throw new Error(FILE_INCORRECT);
  }

  for (let i = 0; i < headers.length; i++) {
    if (header[i] !== headers[i]) {
      throw new Error(FILE_INCORRECT);
    }
  }

  return true;
};
